import { IRootState } from 'app/shared/reducers';
import { createSelector } from 'reselect';
import { View } from '../../domain/View';
import { RulesKeys } from '../../domain/rules.keys';
import { RulesState } from './state';
import _ from 'lodash';

const selectRulesState = (state: IRootState) => state.rules;

export const getRulesDataByKey = (key: RulesKeys) =>
  createSelector<IRootState, RulesState, any>(selectRulesState, (state: RulesState) => state.dataConfList.get(key));

export const getDataViewRules = _.memoize((key: View) =>
  createSelector<IRootState, RulesState, any>(selectRulesState, (state: RulesState) => state.dataViewList.get(key))
);

export const getNavItemsMobile = _.memoize((key: RulesKeys) =>
  createSelector<IRootState, RulesState, any>(selectRulesState, (state: RulesState) => state.dataConfList.get(key))
);
